import store from 'store';
import * as actions from './actions';

const STORED_DRAWER_STATE = (storedDrawerState: object) => {
  const drawerState = {};
  Object.keys(storedDrawerState).forEach(key => {
    const item = store.get(`app.drawerState.${key}`);
    drawerState[key] = typeof item !== 'undefined' ? item : storedDrawerState[key];
  });
  return drawerState;
};

export const initialState: object = {
  // default drawerState, if not exist in localStorage
  ...STORED_DRAWER_STATE({
    isHelpDrawerOpen: false,
    isNotificationsDrawerOpen: false,
  }),
};

export function reducer(state = initialState, action: actions.Actions): object {
  switch (action.type) {
    case actions.SET_DRAWER_STATE:
      const key = Object.keys(action.payload)[0];
      store.set(`app.drawerState.${key}`, action.payload[key]);
      return { ...state, ...action.payload };
    default:
      return state;
  }
}

export const getdrawerState = (state: any) => state;
